import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { getOne } from '../store/offer.store'
import { extendObservable } from 'mobx'
import LoadingPageOverlay from '../components/LoadingPageOverlay'
import { PropTypes } from 'prop-types'
import withRouter from '../components/withRouter'
import t from '../service/translate.service'

class OfferItem extends Component {
  constructor (props) {
    super(props)
    this.id = props.useParams.id

    extendObservable(this, {
      article: {}
    })

    getOne(this.id).then(res => (this.article = res))
  }
  render () {
    const { image, content } = this.article
    return (
      <div>
        {image ? (
          <div className="offer-item">
            <div className="image">
              <img
                src={`https://www.grandcityproperty.de${image.realFullPath}`}
                alt={image.altText || t.PROPERTY_IMAGE}
                role="img"
                aria-labelledby="image-description"
              />
            </div>
            <div
              className="news-article"
              dangerouslySetInnerHTML={{ __html: content }}
              aria-describedby="article-content"
            />
            <div id="image-description" className="sr-only">
              {image.description || t.PROPERTY_IMAGE}
            </div>
          </div>
        ) : (
          <LoadingPageOverlay aria-live="polite" />
        )}
      </div>
    );
  }
}

OfferItem.propTypes = {
  useParams: PropTypes.object
}

export default withRouter(observer(OfferItem))
